// Mock data for Unreal Viz landing page clone (frontend-only)
// NOTE: Images are placeholders — replace `img.*` URLs with the client's real assets.

export const img = {
  hero: 'https://pub-573ad4f6a54444ab869af76eba4bf5b8.r2.dev/hero-home.jpg',
  why: 'https://images.unsplash.com/photo-1706164971302-e30c0640cc3b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  ai: 'https://images.unsplash.com/photo-1766603636700-e9d80473f40f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600',
  aud1: 'https://images.unsplash.com/photo-1581784878214-8d5596b98a01?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  aud2: 'https://images.unsplash.com/photo-1581783458534-001a466b5487?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  aud3: 'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&q=85&w=900',
  project: 'https://images.pexels.com/photos/323780/pexels-photo-323780.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400',
  platform: 'https://images.unsplash.com/photo-1659720879268-818dea77efaa?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400',
  portrait: 'https://images.pexels.com/photos/9618125/pexels-photo-9618125.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=700',
  gallery: [
    'https://images.unsplash.com/photo-1660361338517-8c8fbb3ac264?crop=entropy&cs=srgb&fm=jpg&q=80&w=700',
    'https://images.pexels.com/photos/7031604/pexels-photo-7031604.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500&w=700',
    'https://images.unsplash.com/photo-1581784878214-8d5596b98a01?crop=entropy&cs=srgb&fm=jpg&q=80&w=700',
    'https://images.pexels.com/photos/33599113/pexels-photo-33599113.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500&w=700',
    'https://images.unsplash.com/photo-1613545325278-f24b0cae1224?crop=entropy&cs=srgb&fm=jpg&q=80&w=700',
    'https://images.pexels.com/photos/8092431/pexels-photo-8092431.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=500&w=700',
    'https://images.unsplash.com/photo-1706164971302-e30c0640cc3b?crop=entropy&cs=srgb&fm=jpg&q=80&w=700',
    'https://images.unsplash.com/photo-1502005229762-cf1b2da7c5d6?crop=entropy&cs=srgb&fm=jpg&q=80&w=700',
  ],
};

export const WHATSAPP = 'https://wa.me/393917027312';

export const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'AI', href: '#ai' },
  { label: 'Masterclass', href: '#masterclass' },
  { label: 'Programma', href: '#programma' },
  { label: 'About', href: '#about' },
  { label: 'Prezzi', href: '#prezzi' },
  { label: 'Contatti', href: '#contatti' },
];

export const stats = [
  { value: '70', plus: true, label: 'LEZIONI IN ITALIANO' },
  { value: '150', plus: true, label: 'ORE DI FORMAZIONE' },
  { value: 'UE5', plus: false, label: '3D + Unreal Engine 5' },
  { value: '\u221e', plus: false, label: 'Accesso a vita alle lezioni' },
];

export const audience = [
  {
    n: '01',
    title: 'Hai un background con Vray o Corona?',
    text: 'Ottimo! Se conosci il rendering offline ma sei stanco di aspettare ore per ogni immagine e vuoi imparare i segreti di Unreal e aggiungere il real-time al tuo workflow',
    points: [
      'Pipeline di import da 3ds Max, Rhino, SketchUp',
      'Materiali PBR equivalenti a quelli che gi\u00e0 usi',
      'Velocit\u00e0 di iterazione 10\u00d7 rispetto al render offline',
    ],
    image: 'aud1',
  },
  {
    n: '02',
    title: 'Utilizzi o hai utilizzato Lumion, D5 o Twinmotion?',
    text: 'Hai gi\u00e0 idea di cosa sia il real time rendering, ma probabilmente ti sei accorto che questi software, seppur molto potenti, hanno una serie di limitazioni tecniche quando bisogna affrontare commesse reali, Unreal Engine \u00e8 il salto che stai cercando!',
    points: [
      'Qualit\u00e0 visiva senza precedenti',
      'Controllo totale su luci, animazioni e post-process',
      'Output e settaggi professionali, in base alle esigenze',
    ],
    image: 'aud2',
  },
  {
    n: '03',
    title: 'Sei un Architetto o un Interior designer?',
    text: 'Questo \u00e8 il posto giusto se vuoi imparare a presentare i tuoi progetti in modo completamente diverso. Walkthrough interattivi, video cinematografici, rendering fotorealistici, esperienze che i clienti non dimenticano',
    points: [
      'Presentazioni indimenticabili ai tuoi clienti',
      'Meno revisioni e incomprensioni, pi\u00f9 chiarezza progettuale',
      'Portfolio che si distingue dalla massa',
    ],
    image: 'aud3',
  },
];

export const lessons = [
  { n: '01', tag: 'INTRODUZIONE', title: "Il mercato dell'Archviz e la rivoluzione Unreal Engine", text: 'Capisci perch\u00e9 Unreal Engine ha cambiato le regole del settore \u2014 e perch\u00e9 chi lo usa oggi ha gi\u00e0 un vantaggio reale. Non partiamo dal software. Partiamo dal perch\u00e9.' },
  { n: '02', tag: 'MODELLAZIONE 3D', title: 'Le fondamenta, modellazione e ambiente virtuale', text: 'Prima di entrare in Unreal, costruiamo la base giusta. Proporzioni, modellazione corretta, UV mapping \u2014 tutto quello che determina la qualit\u00e0 finale del risultato. Un render \u00e8 buono quando il modello \u00e8 gestito correttamente.' },
  { n: '03', tag: 'IMPORTAZIONI E PIPELINE', title: 'Flusso corretto di importazioni dai diversi software ad Unreal', text: 'Rhino, 3ds Max, Archicad, SketchUp \u2014 qualunque sia il tuo software, impari a importare correttamente senza perdere qualit\u00e0. La pipeline giusta ti fa risparmiare ore su ogni progetto.' },
  { n: '04', tag: 'ILLUMINAZIONE', title: 'Let there be light \u2014 La luce \u00e8 la base di ogni visualizzazione', text: "L'illuminazione \u00e8 l'80% del risultato finale. Luce solare, HDRI, luci artificiali, sky atmosphere \u2014 costruiamo scene che sembrano reali (+ bonus con Plugin fantastici)." },
  { n: '05', tag: 'MATERIALI', title: 'Superfici che sembrano vere', text: 'Materiali PBR, librerie esclusive Unreal Viz, vetro, legno, cemento, metallo etc. Impari a costruire materiali da zero e a usare quelli gi\u00e0 pronti in modo professionale.' },
  { n: '06', tag: 'GESTIONE PROGETTO', title: 'Organizzazione, performance e controllo del file', text: 'Scene grandi, asset complessi, performance ottimizzate. Impari a gestire un progetto reale senza perderti nel caos \u2014 World Outliner, Foliage Tool, Blueprint per la gestione avanzata.' },
  { n: '07', tag: 'OUTPUT DI ESPORTAZIONI', title: 'Ciak, si gira! Rendering, animazioni e cinematiche', text: 'Post-processing, composizione fotografica, color grading. Impari a produrre immagini e video al livello dei grandi studi \u2014 con la cinecamera virtuale in mano.' },
  { n: '08', tag: 'RENDERING', title: 'Le corrette esportazioni', text: 'Render di qualit\u00e0 cinematografica direttamente da Unreal Engine. Il Movie Render Queue ti permette di esportare immagini e sequenze con anti-aliasing avanzato e ray tracing spinto al massimo.' },
  { n: '\u2605', tag: 'BONUS FUTURO \u00b7 AI', title: 'Collaborazione tra Unreal e AI', text: 'In arrivo e presentato in anteprima agli studenti della Unreal Viz Masterclass.' },
];

export const pricing = [
  {
    n: '01', name: 'PACCHETTO BASIC', price: '299',
    desc: 'Il punto di partenza. Dalle fondamenta del 3D fino ai render fotorealistici in Unreal Engine.',
    features: [
      { t: '48 lezioni pre-registrate', on: true },
      { t: 'Accesso alla piattaforma 24/7', on: true },
      { t: 'Asset e file scaricabili (limitati)', on: true },
      { t: 'Accesso al gruppo privato Unreal Viz', on: true },
      { t: 'Aggiornamenti futuri inclusi', on: true },
      { t: 'Lezioni Advanced', on: false },
      { t: 'Librerie materiali Unreal Viz', on: false },
      { t: 'Plugin esclusivi Unreal Viz', on: false },
    ],
    cta: 'Accedi al corso Basic', featured: false,
  },
  {
    n: '02', name: 'PACCHETTO ADVANCED', price: '379',
    desc: 'Il percorso completo. Tutto il Basic pi\u00f9 le lezioni avanzate, le librerie e i plugin esclusivi.',
    features: [
      { t: '70 lezioni pre-registrate', on: true },
      { t: 'Tutto il pacchetto Basic incluso', on: true },
      { t: 'Lezioni Advanced esclusive', on: true },
      { t: 'Librerie materiali Unreal Viz', on: true },
      { t: 'Plugin esclusivi Unreal Viz', on: true },
      { t: 'Codice referral \"presenta un amico\"', on: true },
      { t: 'Accesso al gruppo privato Unreal Viz', on: true },
      { t: 'Aggiornamenti futuri inclusi', on: true },
    ],
    cta: "Scegli l'ADVANCED", featured: true,
  },
  {
    n: '03', name: 'PACCHETTO WORKER', price: '479',
    desc: "Per chi vuole supporto diretto. Tutto l'Advanced pi\u00f9 sessioni video call sul tuo progetto specifico.",
    features: [
      { t: "Tutto il pacchetto Advanced incluso", on: true },
      { t: '120 min di supporto diretto in video call', on: true },
      { t: '2-3 sessioni sul tuo progetto specifico', on: true },
      { t: 'Supporto richiedibile entro 12 mesi', on: true },
      { t: 'Feedback diretto da Matteo sul tuo lavoro', on: true },
    ],
    cta: 'Accedi al Worker', featured: false,
  },
];

export const testimonials = [
  { name: 'Arch. Luca Pandini', text: 'Ho seguito la masterclass di Matteo su Unreal Engine e posso dire con certezza che \u00e8 stata una delle esperienze formative pi\u00f9 complete e coinvolgenti che abbia mai fatto.' },
  { name: 'Matteo Bernardi', text: 'Dopo anni passati con Lumion e Twinmotion, ho deciso di fare il salto. Il corso di Matteo mi ha aperto un mondo: non solo sulla qualit\u00e0 visiva, ma proprio sul workflow professionale. Non \u00e8 il solito corso base\u2026 qui si lavora sul serio.' },
  { name: 'Giulia Fabbri', text: 'Ho lavorato con V-Ray per anni, ma mi ero stufato dei tempi infiniti. Unreal mi sembrava troppo complicato finch\u00e9 non ho trovato questo corso. Matteo spiega come uno che ci lavora davvero, senza giri di parole. Super consigliato!' },
  { name: 'Federico Puglisi', text: 'Non ero sicuro che fosse il corso adatto a me. In realt\u00e0 \u00e8 il contrario: il corso \u00e8 pensato per formarti come professionista, indipendentemente da dove vieni. Le lezioni sono pratiche, ordinate, e soprattutto ti insegnano a lavorare bene ed ordinato.' },
  { name: 'Davide Rinaldi', text: 'Da buon scettico, ho riempito Matteo di domande prima di entrare nella Masterclass, super disponibile fin da subito. Dopo le prime lezioni ho capito che Matteo parte subito con un approccio molto concreto, mostra flussi di lavoro reali. Ora sto gi\u00e0 applicando molte cose nei miei progetti.' },
];

export const faqs = [
  { q: 'Il corso \u00e8 adatto anche a chi parte da zero con Unreal Engine?', a: 'Assolutamente s\u00ec. Il percorso \u00e8 pensato per guidarti passo dopo passo, anche se non hai mai aperto Unreal Engine. Le lezioni ti portano dalle basi fino a tecniche avanzate.' },
  { q: '\u00c8 un corso adatto anche a chi lavora gi\u00e0 nel settore?', a: 'S\u00ec. Anche i professionisti troveranno flussi di lavoro, ottimizzazioni e tecniche avanzate che possono integrare direttamente nelle commesse reali.' },
  { q: 'Quanto tempo ci vuole per completare il corso?', a: 'Il corso \u00e8 pre-registrato e lo segui ai tuoi ritmi. In media gli studenti lo completano in 6-10 settimane, ma hai accesso a vita.' },
  { q: 'Che differenza c\u2019\u00e8 rispetto a Lumion, D5, Twinmotion o Enscape?', a: 'Unreal Engine offre controllo, qualit\u00e0 e libert\u00e0 creativa senza paragoni. Nel corso capirai quando e perch\u00e9 conviene fare il salto rispetto a questi software.' },
  { q: 'Posso scaricare gli asset e i file usati nelle lezioni?', a: 'S\u00ec, per ogni lezione trovi asset e file scaricabili (in base al pacchetto scelto) cos\u00ec puoi seguire ed esercitarti sugli stessi progetti.' },
  { q: '\u00c8 previsto un supporto in caso di difficolt\u00e0?', a: 'Certo. Hai accesso al gruppo privato Unreal Viz, e con il pacchetto Worker ricevi supporto diretto in video call da Matteo.' },
  { q: 'Ricever\u00f2 aggiornamenti futuri del corso?', a: 'S\u00ec, tutti i pacchetti includono gli aggiornamenti futuri senza costi aggiuntivi.' },
];
